<template>
    <div class="ClientCreateModal">
        <h1>Add Client</h1>

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <div class="main">
            <ClientForm
                ref="clientForm"
                v-bind.sync="client"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Save</Button>
        </div>
    </div>
</template>

<script>
import ClientForm from '@/views/company/client/components/ClientForm';
import clientCreateMixin from '@/mixins/clientCreateMixin';

export default {
    name: 'ClientCreateModal',

    mixins: [clientCreateMixin],

    components: { ClientForm },

    props: {
        onClientCreated: { type: Function, required: true },
    },

    mounted() {
        this.$analytics.trackModalView(this.$options.name);
    },

    methods: {
        async handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'save', {
                model_type: 'client',
                model_action: 'create',
            });

            const newClient = await this.createClient();
            if (newClient) {
                this.onClientCreated(newClient);
                this.$emit('close');
            }
        },

        handleCancel() {
            this.$analytics.trackButtonClick(this.$options.name, 'cancel', {
                model_type: 'client',
                model_action: 'create_cancel',
            });

            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ClientCreateModal {
    @extend %modal;

    .main {
        max-height: 60vh;
        overflow-y: auto;
        margin: 1rem 0;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
    }

    .errorMessage {
        margin: 1rem 0;
        color: $red-color;
        text-align: center;
    }
}
</style>
